import {
  AP_PENDING,
  AP_BOOTSTRAP,
  AP_SUBMIT,
  AP_CHECKIN_SUBMIT,
  AP_STATUS_OPTIONS,
  AP_ERROR,
  ALL_ERRORS,
  CLEAR_ALL,
  AP_GET_MY_REPORTS,
  AP_GET_REPORT_PDF,
} from 'constants/actions.js';

function normalizeReports(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.reports)) return raw.reports;
  if (Array.isArray(raw?.data?.reports)) return raw.data.reports;
  if (Array.isArray(raw?.data)) return raw.data;
  if (Array.isArray(raw?.results)) return raw.results;
  if (Array.isArray(raw?.items)) return raw.items;
  if (Array.isArray(raw?.data?.results)) return raw.data.results;
  if (Array.isArray(raw?.data?.items)) return raw.data.items;
  return [];
}

const initialState = {
  pending: false,
  loading: true,
  loadingBootstrap: false,
  submitting: false,
  submittingCheckin: false,
  token: null,
  kind: null, // 'plan' | 'update'
  events: [],
  actions: [],
  activeEvent: null,
  campaignId: null,
  requiredActionsCount: 3,
  statusOptions: [],
  submit: null,
  checkinSubmit: null,
  error: null,
  invalidToken: false,
  reports: [],
  reportDownload: null,
  downloadingReport: false,
};

export default function ActionPlan(state = initialState, action) {
  switch (action.type) {
    case AP_PENDING: {
      const phase = action?.meta?.phase ?? null;
      return {
        ...state,
        pending: true,
        loading: phase !== 'report_pdf',
        loadingBootstrap: phase === 'bootstrap',
        submitting: phase === 'submit',
        submittingCheckin: phase === 'checkin_submit',
        downloadingReport: phase === 'report_pdf',
        reportDownload: phase === 'report_pdf' ? null : state.reportDownload,
        error: null,
        invalidToken: false,
      };
    }
    case AP_BOOTSTRAP:
      return {
        ...state,
        pending: false,
        loading: false,
        loadingBootstrap: false,
        submitting: false,
        submittingCheckin: false,
        token: action.payload?.token ?? null,
        kind: action.payload?.kind ?? null,
        events: action.payload?.events ?? [],
        actions: action.payload?.actions ?? [],
        activeEvent: action.payload?.activeEvent ?? null,
        campaignId: action.payload?.campaignId ?? null,
        requiredActionsCount: action.payload?.requiredActionsCount ?? state.requiredActionsCount,
        reportDownload: null,
        downloadingReport: false,
        error: null,
        invalidToken: false,
      };
    case AP_SUBMIT:
      return {
        ...state,
        pending: false,
        loading: false,
        loadingBootstrap: false,
        submitting: false,
        submittingCheckin: false,
        submit: action.payload,
        error: null,
        invalidToken: false,
      };
    case AP_STATUS_OPTIONS:
      return {
       ...state,
       statusOptions: Array.isArray(action.payload) ? action.payload : [],
      };
    case AP_CHECKIN_SUBMIT:
      return {
        ...state,
        pending: false,
        loading: false,
        loadingBootstrap: false,
        submitting: false,
        submittingCheckin: false,
        checkinSubmit: action.payload,
        error: null,
        invalidToken: false,
      };
    case AP_GET_MY_REPORTS:
      return {
        ...state,
        pending: false,
        loading: false,
        loadingBootstrap: false,
        submitting: false,
        submittingCheckin: false,
        reports: normalizeReports(action.payload),
        error: null,
        invalidToken: false,
      };
    case AP_GET_REPORT_PDF:
      return {
        ...state,
        pending: false,
        loading: false,
        loadingBootstrap: false,
        submitting: false,
        submittingCheckin: false,
        downloadingReport: false,
        reportDownload: action.payload ?? null,
        error: null,
        invalidToken: false,
      };
    case AP_ERROR:
    case ALL_ERRORS:
      {
        const err = action.message ?? action.error ?? action;
        const status = err?.status ?? err?.status_code ?? err?.response?.status ?? null;
      return {
        ...state,
        pending: false,
        loading: false,
        loadingBootstrap: false,
        submitting: false,
        submittingCheckin: false,
        downloadingReport: false,
        error: err,
        invalidToken: status === 403,
      };
      }
    case CLEAR_ALL:
      return { ...initialState };
    default:
      return state;
  }
}
